(ns com.theplantscape.plant-web.components.tailwind.toolbars)

(defn header-logo [icon-cb]
  [:div.flex.items-center.flex-shrink-0.text-white
   [:svg.fill-current.h-8.w-8.mr-2
    {:title "Garden Design" :width "54" :height "54" :viewBox "0 0 54 54"
     :xmlns "http://www.w3.org/2000/svg" :on-click (when icon-cb  icon-cb)}
    [:path {:d "M13.5 22.1c1.8-7.2 6.3-10.8 13.5-10.8 10.8 0 12.15 8.1 17.55 9.45 3.6.9 6.75-.45 9.45-4.05-1.8 7.2-6.3 10.8-13.5 10.8-10.8 0-12.15-8.1-17.55-9.45-3.6-.9-6.75.45-9.45 4.05zM0 38.3c1.8-7.2 6.3-10.8 13.5-10.8 10.8 0 12.15 8.1 17.55 9.45 3.6.9 6.75-.45 9.45-4.05-1.8 7.2-6.3 10.8-13.5 10.8-10.8 0-12.15-8.1-17.55-9.45-3.6-.9-6.75.45-9.45 4.05z"}]]
   [:span.font-semibold.hidden.lg-text-lg.md-text-xl.tracking-tight.md:block
    #_"thePlantScape"
    "Create a plant scape"]])

(defn responsive-toolbar
  [left right {:keys [icon-cb]}]
  [:nav.flex.h-16.content-center.w-full.items-center.justify-between.flex-wrap.bg-teal-500.p-4
   [header-logo icon-cb]
   #_[:div.block
      [:button.flex.items-center.px-3.py-2.border.rounded.text-teal-200.border-teal-400.hover:text-white.hover:border-white
       [:svg.fill-current.h-3.w-3 {:viewbox "0 0 20 20" :xmlns "http://www.w3.org/2000/svg"}
        [:title "Menu"]
        [:path {:d "M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"}]]]]
   [:div.block.grow.flex.items-center.w-auto
    [:div.text-sm.grow left]
    [:div right]]])
